export default {
  appName: "Cribbage",
  gameId: 6,
  version: "3.18.0",
  debug: false,
  ios: '1362318446',
  android: 'com.jdsoftwarellc.cribbage',
  windows: '9ntj99b0pblj',
  amazon: 'B07BMRYW6D',
  webRateURL: 'https://g.page/r/CfKGerjowq36EBM/review',
  email: 'cribbage@jdsoftwarellc.com',
  emailSubject: 'Cribbage Feedback',
  os: null,
  shareUrl: 'https://cardsjd.com/cribbage/',
  shareTitle: 'Cribbage',
  shareText: "Let's play Cribbage",
  shareImage: './assets/Icons/Icon_512x512.png',
  gamesUrl: 'https://cardsjd.com/config/moregames.json',
  storageName: 'cribbage.userdata',
  accountJDUrl: 'https://account.jdsoftwarellc.com/',
  gameServerUrl: 'wss://cribbageserver.jimmyinteractive.com',
  gamificationUrl: 'https://gamification.jdsoftwarellc.com/'
}